import { LockOutlined } from '@ant-design/icons';

import styles from './UnavailableSection.module.scss';

interface IProp {
  unavailableText: string;
}

export const UnavailableSection = ({ unavailableText }: IProp) => (
  <div className={styles.wrapper}>
    <LockOutlined className={styles.icon} />
    <p className={styles.description}>{unavailableText}</p>
  </div>
);
